'use client'

import { ReactNode } from 'react'
import { App } from '@App'

export function AppWrapper({ children }: { children: ReactNode }) {
  return <App>{children}</App>
}
